import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.fileExists)?_c(VTooltip,{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('img',_vm._g(_vm._b({key:_vm.platform,attrs:{"src":_vm.platformImageSrc,"alt":_vm.platformName}},'img',attrs,false),on))]}}],null,false,3584757578)},[_c('span',[_vm._v(_vm._s(_vm.platformName)+"'s icon is not found")])]):_c('img',{key:_vm.platform,attrs:{"src":_vm.platformImageSrc,"alt":_vm.platformName}})}
var staticRenderFns = []

export { render, staticRenderFns }